import React from "react";

const StudyDetailsCanada = () => {
  return (
    <div>
      <div class="hero mt-20 mb-16">
        <div class="hero-content flex-col lg:flex-row-reverse">
          <img
            src="https://i.ibb.co/MB6Mysm/Frame-27-5.png"
            class="admission"
          />
          <div>
            <div className="justify-center">
              <h1 class="text-start  text-5xl font-medium text-primary text-3xl font-italic text-gold-600">
                Best place
                <span className="text-secondary">study in the world</span>
              </h1>

              <p class="mt-8 text-lg text-justify lg:w-10/12 ">
                Lorem ipsum dolor sit amet consectetur. Lacus accumsan elementum
                non et tristique vitae. Pharetra vulputate laoreet consectetur
                viverra pellentesque augue mauris odio. Magna pretium neque amet
                nullam donec sit netus nisl amet. Orci libero rhoncus lectus
                viverra orci a etiam. Elementum erat tincidunt senectus nunc
                adipiscing maecenas eget consequat. Commodo tincidunt lectus
                egestas scelerisque. Felis dui dolor metus neque sit nulla dui.
                Vitae nulla erat quis ut iaculis imperdiet turpis. Id justo
                purus arcu lectus consectetur sollicitudin vel donec vel. Eget
                nunc morbi urna elementum eleifend nisi sem elementum. Semper
                urna tincidunt at sollicitudin vitae dui aliquam sagittis non.
                Augue lectus eu nunc facilisi sagittis dignissim. Lorem in
                ultrices mi sed. Eget vitae urna lectus morbi id vitae tristique
                viverra scelerisque. Vestibulum nam laoreet a massa eget. Nisi
                viverra urna ornare adipiscing. Nibh tellus aliquet risus platea
                sollicitudin dui sodales. Erat purus bibendum ultrices quis ut
                pellentesque. Sed velit interdum sit turpis consectetur.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="hero mt-20 mb-16 bg-slate-100 ">
        <div class="hero-content flex-col lg:flex-row mt-14 mb-16">
          <img src="https://i.ibb.co/LQ99PwP/Frame-29.png" class="admission" />
          <div>
          <div className='justify-center'>
                  <h1 class="text-start lg:ml-36 text-5xl font-medium text-primary text-3xl font-italic text-gold-600">Academic <span className='text-secondary'>Excellence</span> </h1>
               
                  <p class="mt-12 text-lg text-justify lg:w-10/12 lg:ml-28">Canada has a fine reputation for providing a first-class education to students across the board. Degrees from Canadian universities, colleges, and institutions are largely accepted all over the world and thus, offer a high graduate employability rate. Moreover, once you choose Canada as your study destination, you will encounter several universities that rank among the top 100 universities worldwide, including the University of Toronto, University of British Columbia, University of Alberta, Université de Montréal, McGill University, and a few others.</p>
               
                </div>
          </div>
        </div>
      </div>

      <div class="hero mt-20 mb-16">
        <div class="hero-content flex-col lg:flex-row-reverse">
          <img
            src="https://i.ibb.co/MB6Mysm/Frame-27-5.png"
            class="admission"
          />
          <div>
            <div className="justify-center">
              <h1 class="text-start  text-5xl font-medium text-primary text-3xl font-italic text-gold-600">
              Work Opportunity
                <span className="text-secondary"> During and Post Study</span>
              </h1>

              <p class="mt-8 text-lg text-justify lg:w-10/12 ">
              Students applying to Canada for study purposes gain appealing benefits of on-campus work, off-campus work, co-op placements, and internships for up to 20 hours weekly while continuing their studies. It is indeed a great way to gather practical expertise as well as minimise living costs. Moreover, once you complete your degree in Canada, you will be eligible to apply for a post-study work permit for up to 3 years meeting these stated requirements:
              <li className="mt-7">You must be a full-time student in Canada and your course duration should be at least eight months.</li>
              <li>You should apply for a work permit within 180 days of completing your course. Also, you must submit written proof, either a transcript or an official letter, from your college or university.</li>
              <li>You must show a valid student visa while applying for the PGWP.</li>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="hero mt-20 mb-16 bg-slate-100 ">
        <div class="hero-content flex-col lg:flex-row mt-14 mb-16">
          <img src="https://i.ibb.co/LQ99PwP/Frame-29.png" class="admission" />
          <div>
          <div className='justify-center'>
                  <h1 class="text-start lg:ml-36 text-5xl font-medium text-primary text-3xl font-italic text-gold-600">Permanent <span className='text-secondary'>Residency Opportunities</span> </h1>
               
                  <p class="mt-12 text-lg text-justify lg:w-10/12 lg:ml-28">Another notable perk of choosing Canada is the country’s immigration-friendly policies for international applicants. By following a few steps required by the Immigration, Refugees and Citizenship Canada (IRCC), you can continue living and working with a Permanent Residency (PR) right after completing graduation or earning requisite work experience.</p>
               
                </div>
          </div>
        </div>
      </div>

      <div class="hero mt-20 mb-16">
        <div class="hero-content flex-col lg:flex-row-reverse">
          <img
            src="https://i.ibb.co/MB6Mysm/Frame-27-5.png"
            class="admission"
          />
          <div>
            <div className="justify-center">
              <h1 class="text-start  text-5xl font-medium text-primary text-3xl font-italic text-gold-600">
              Safe and
                <span className="text-secondary"> Peaceful <br /> Environment</span>
              </h1>

              <p class="mt-8 text-lg text-justify lg:w-10/12 ">
              As per the Global Peace Index (GPI) report, Canada ranks at top of the list as one of the safest and most peaceful countries in the world with low crime rates, high interpersonal harmony among people, and rapid sustainable development. International students find studying and living in Canada immensely exciting by the dint of its diverse culture and welcoming citizens from multicultural communities. Alongside, the major cities in Canada such as Toronto, Montreal, Vancouver, Ottawa, Quebec, and many others, offer a vibrant and lively atmosphere, where foreign students can combine an enriching academic and professional life with entertaining leisure activities.
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default StudyDetailsCanada;
